<template>
  <div v-if="isVisible" class="information-alert-container">
    <v-alert
      class="information-alert"
      outlined
      color="primary"
      border="left"
    >
      <div class="d-flex justify-space-between align-start">
        <div class="d-flex align-start flex-grow-1">
          <v-icon color="primary" class="mr-3" size="20">
            mdi-bullhorn
          </v-icon>
          <div class="flex-grow-1">
            <div class="info-title font-weight-bold primary--text">{{ title }}</div>
            <div v-if="description" class="info-description mt-1">{{ description }}</div>
            <div class="info-content" :class="{ 'mt-1': description || title }">
              <slot>
                <ul v-if="items && items.length" class="info-list ma-0 pl-4">
                  <li v-for="(item, index) in items" :key="index">
                    {{ item }}
                  </li>
                </ul>
                <p v-else-if="message" class="ma-0">{{ message }}</p>
              </slot>
            </div>
          </div>
        </div>
        <v-btn
          v-if="dismissible"
          icon
          small
          class="ml-2"
          @click="closeAlert"
        >
          <v-icon size="18">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'InformationAlert',
  props: {
    title: {
      type: String,
      default: 'Information'
    },
    description: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    dismissible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVisible: true
    };
  },
  methods: {
    closeAlert() {
      this.isVisible = false;
      this.$emit('close');
    },
    show() {
      this.isVisible = true;
    }
  }
};
</script>

<style scoped>
.information-alert-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 14px;
}

.information-alert {
  background-color: #fff !important;
  width: 100%;
  margin: 0 !important;
}

.info-title {
  font-size: 14px;
}

.info-description {
  font-size: 13px;
  font-weight: 500;
}

.info-content {
  font-size: 12px;
  line-height: 1.6;
}

.info-list {
  list-style-type: disc;
}

.info-list li {
  margin-bottom: 2px;
}
</style>
